import axiosInstance from '../../../config/axiosInstance';
const  JobRecurService = {
    async GetAllJobRecurr(redirectCallback,IssueID) {
        try {            
            const response = await axiosInstance.get(`/Job/GetAllJobRecur?IssueID=${IssueID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetJobRecur(redirectCallback,IssueID) {
        try {            
            const response = await axiosInstance.get(`/Job/GetJobRecur?IssueID=${IssueID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async DeleteJobRecur(ID,redirectCallback) {
        try {
            const response = await axiosInstance.get(`/Job/DeleteJobRecur?ID=${ID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async DeleteJobRecurByID(ID,redirectCallback) {
        try {
            const response = await axiosInstance.get(`/Job/DeleteJobRecurByID?ID=${ID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    }
};

export default JobRecurService;